export default __webpack_public_path__ + "static/media/link.cfc7b989.svg";